import { onAuthChange } from '../auth/firebaseAuth';
import { FETCH_USER } from './types';

// Subscribe to Identity Platform auth state and mirror it into the redux `auth`
// slice (replaces the old passport /api/current_user fetch). Dispatches the
// signed-in user's claims object ({ uid, email, tenantId, role }) or false when
// signed out; the reducer leaves it null until the first event (loading).
// Returns the unsubscribe function.
export const listenForAuth = () => (dispatch) =>
  onAuthChange((claims) => {
    dispatch({ type: FETCH_USER, payload: claims || false });
  });
